<div class='admissions-overview-tab-2-part'>
	<acc-offered-seat-counts-part></acc-offered-seat-counts-part>
</div>